import { useSystemStore } from '@/stores/systemStore';
import { injectStrict } from '@/utils/injectStrict';
import { useHubSubscription } from '@/utils/signalR';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { InjectionKey } from 'vue';

export const MaintenanceModeHubKey: InjectionKey<HubConnection> = Symbol('MaintenanceModeHubKey');

export function getMaintenanceModeHubConnectionSignalR() {
  const connection = new HubConnectionBuilder()
    .withUrl('/maintenanceModeHub')
    .withAutomaticReconnect([0, 2000, 10000, 30000])
    .build();
  return connection;
}

export function useMaintenanceModeSignalR() {
  const connection = injectStrict(MaintenanceModeHubKey);

  useHubSubscription<void>({
    connection,
    event: 'MaintenanceModeChanged',
    onMessage: () => {
      useSystemStore()
        .fetchMaintenanceModeInfo()
        .catch((error) => {
          console.error(
            'SignalR MaintenanceModeChanged: failed to refresh maintenance mode',
            error,
          );
        });
    },
    subscribe: () => Promise.resolve(),
    unsubscribe: () => Promise.resolve(),
  });
}
